<script setup lang="ts">
/* __placeholder__ */
import type { PostOrPage } from '@tryghost/content-api';

const route = useRoute();

useHead({
  title: "Privacy Policy - ZapScale's Commitment to Data Privacy and Security",
  meta: [
    {
      name: 'description',
      content:
        "Read ZapScale's privacy policy to understand our commitment to data privacy and security in delivering our customer success solutions.",
    },
    {
      property: 'og:description',
      content:
        "Read ZapScale's privacy policy to understand our commitment to data privacy and security in delivering our customer success solutions.",
    },
    {
      property: 'og:title',
      content: "Privacy Policy - ZapScale's Commitment to Data Privacy and Security",
    },
    {
      property: 'og:url',
      content: 'https://www.zapscale.com' + route.path,
    },
    {
      name: 'twitter:card',
      content: 'summary',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: 'https://www.zapscale.com' + route.path,
    },
  ],
});

useJsonld(() => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'ZapScale',
  description:
    'A single-source customer success management SaaS platform with 50 pre-built playbooks, 40 out-of-the-box KPIs, and unlimited user logins.',
  url: 'https://www.zapscale.com/',
  logo: 'https://www.zapscale.com/images/Header_logo.svg',
  sameAs: [
    'https://www.facebook.com/zapscale',
    'https://www.linkedin.com/company/zapscale/',
    'https://twitter.com/ZapScale',
  ],
}));

const slug = route.name as string;

const { pending: loading, data: page } = await useFetch<PostOrPage>(`/api/pages/${slug}`);

onMounted(() => {
  let pageHtml = document.getElementById('page-html') as Element;
  pageHtml.innerHTML = page.value?.html as string;

  let unorderedList = pageHtml.getElementsByTagName('ul');
  let orderedList = pageHtml.getElementsByTagName('ol');

  for (let i = 0; i < unorderedList.length; i++) {
    let element = unorderedList[i];
    element.style.listStyleType = 'disc';
  }

  for (let i = 0; i < orderedList.length; i++) {
    let element = orderedList[i];
    element.style.listStyleType = 'decimal';
  }
});
</script>
<template>
  <div class="bg-[#f9f7f5]">
    <div class="container mx-auto">
      <div class="px-5 py-10">
        <h1 class="text-4xl font-extrabold text-[#3a3a3c] md:text-6xl">Privacy Policy</h1>
        <article id="page-html" class="prose-sm text-[#3a3a3c]"></article>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
